import { FDDateInput } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import PropTypes from 'prop-types';
import { useDataAttrs } from 'Helpers/Testing';

const DateInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    readonly,
    required,
    size,
    value,
    inputFormat,
    labelPlacement,
    ...rest
  } = props;

  return (
    <FDDateInput
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur === null ? undefined : onBlur}
      onChange={(val) => {
        // If you're having changing this then consider this is used inside MetaForm and will be handled in /MetaControl/Date.jsx

        // This originally passed undefined to the date component
        if (val === undefined) {
          return onChange('');
        }

        // Otherwise it's an ISO formatted string from FDDateInput and just pass that along
        return onChange(val);
      }}
      onFocus={onFocus}
      placeholder={placeholder}
      required={required}
      size={size}
      inputFormat={inputFormat}
      labelPlacement={labelPlacement}
      value={(value === '' || value === null) ? undefined : value}
    />
  );
};

DateInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  placeholder: inputDefaultProps.placeholder,
  readonly: inputDefaultProps.readonly,
  required: inputDefaultProps.required,
  inputFormat: undefined,
};

DateInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: inputPropTypes.label,
  placeholder: inputPropTypes.placeholder,
  size: inputPropTypes.size.isRequired,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: inputPropTypes.value.isRequired,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  fullWidth: inputPropTypes.fullWidth,
  readonly: inputPropTypes.readonly,
  required: inputPropTypes.required,
  inputFormat: PropTypes.string,
  labelPlacement: inputPropTypes.labelPlacement,
};

const DateInputSmall = (props) => {
  return <DateInput {...props} size="sm" />;
};

const DateInputLarge = (props) => {
  return <DateInput {...props} size="lg" />;
};

export { DateInputSmall, DateInputLarge };
